export const BASE_URL = 'http://localhost:8080/api';

export const ENDPOINTS = {
  forgotPassword: '/api/v1/staff/forgot-password',
  feedbacks: 'assets/data/feedback-data.json',
};
